/* global axios */
import ApiClient from './ApiClient';

// AS PENDÊNCIAS de quem está logado (18/10/2026): o que espera uma decisão, de todos os
// módulos. O contador pergunta a cada minuto; a gaveta pede a lista.
class PendenciasAPI extends ApiClient {
  constructor() {
    super('pendencias', { accountScoped: true });
  }

  contagem(escopo = 'meus') {
    return axios.get(`${this.url}/contagem`, { params: { escopo } });
  }

  lista(escopo = 'meus') {
    return axios.get(this.url, { params: { escopo } });
  }

  // Fatia 4 (20/10/2026): a caixa única.
  // "Já lancei" (acao 'lancou') ou "Não é honorário" ('nao_e') — 23/10/2026.
  decidirHonorario(id, acao) {
    return axios.post(`${this.url}/honorarios/${id}/decidir`, { acao });
  }

  decidirAndamento(id, acao) {
    return axios.post(`${this.url}/andamentos/${id}/decidir`, { acao });
  }

  adiar(tipo, id) {
    return axios.post(`${this.url}/adiar`, { tipo, id });
  }

  // O "Desfazer" (20/10/2026): do "Já vi" (só quem marcou, nos primeiros minutos) e do "Adiar".
  desfazerAndamento(id) {
    return axios.post(`${this.url}/andamentos/${id}/desfazer`);
  }

  desadiar(tipo, id) {
    return axios.delete(`${this.url}/adiar`, { data: { tipo, id } });
  }

  ajustes() {
    return axios.get(`${this.url}/ajustes`);
  }

  salvarAjustes(dados) {
    return axios.patch(`${this.url}/ajustes`, dados);
  }

  numeros(dias = 30) {
    return axios.get(`${this.url}/numeros`, { params: { dias } });
  }
}

export default new PendenciasAPI();
